export const education = {
    topic_sv: "Utbildning",
    text1_sv: "Vi kan bidra med både föreläsningar och workshops när er personal behöver utbilda sig. Behöver ni exempelvis en genomgång av grunderna i devops, en uppfräschning av kunskaperna om agila arbetssätt, eller en mer avancerad kurs i funktionell programmering? Firebric är det självklara valet!"
}
